<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading" class="bg-grey-lighten-4 elevation-0">
          <v-toolbar color="primary" density="comfortable">
            <v-toolbar-title class="text-white">
              {{ title }}
            </v-toolbar-title>
            <v-spacer />
            <div class="d-flex ga-2">
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn icon variant="text" v-bind="props" @click="cancel">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </template>
                Fermer
              </v-tooltip>
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn icon variant="text" v-bind="props" @click="save">
                    <v-icon>mdi-content-save-all</v-icon>
                  </v-btn>
                </template>
                Sauvegarder
              </v-tooltip>
              <v-tooltip location="left">
                <template #activator="{ props }">
                  <v-btn
                    icon
                    variant="text"
                    v-bind="props"
                    :disabled="isCreatingNewAccount"
                    @click="createNewLaverie"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                Créer une laverie
              </v-tooltip>
            </div>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col md="4" cols="12">
                  <v-text-field
                    name="name"
                    maxlength="100"
                    counter="100"
                    hint="Le nom du siège"
                    type="text"
                    v-model="account.name"
                    :rules="rules.accountName"
                  >
                    <template #label>
                      Nom Du Siège<span class="text-red"><strong> *</strong></span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field
                    name="signataire"
                    maxlength="100"
                    counter="100"
                    hint="Le nom du signataire"
                    type="text"
                    v-model="account.signataire"
                    :rules="rules.accountSignataire"
                  >
                    <template #label>
                      Signataire<span class="text-red"><strong> *</strong></span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field
                    name="Fonction du signataire"
                    maxlength="100"
                    counter="100"
                    hint="La fonction du signataire"
                    type="text"
                    v-model="account.fonctionSignataire"
                    :rules="rules.accountFonctionSignataire"
                  >
                    <template #label>
                      Fonction du signataire<span class="text-red"
                        ><strong> *</strong></span
                      >
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field
                    name="telephone"
                    label="Téléphone"
                    maxlength="20"
                    counter="20"
                    hint="Le numero de téléphone"
                    type="text"
                    v-model="account.telephone"
                    :rules="rules.phoneNb"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field
                    label="Courriel"
                    name="email"
                    maxlength="100"
                    counter="100"
                    hint="L'adresse email du siège"
                    type="text"
                    v-model="account.email"
                    :rules="rules.email"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-autocomplete
                    :items="familleLaveries"
                    label="Famille"
                    v-model="account.famille"
                  ></v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-autocomplete
                    :items="accountOrigins"
                    label="Origine"
                    v-model="account.origineCompte"
                  ></v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-autocomplete
                    :loading="!users.length"
                    :items="users"
                    item-title="fullName"
                    item-value="fullName"
                    label="Nom du porteur du projet"
                    v-model="account.porteurProjet"
                  ></v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    name="siret"
                    label="Siret"
                    maxlength="20"
                    counter="20"
                    hint="Siret du siège"
                    type="text"
                    v-model="account.siret"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    name="website"
                    label="Website"
                    maxlength="100"
                    counter="100"
                    hint="Le website du siège"
                    type="text"
                    v-model="account.website"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    name="numero"
                    maxlength="15"
                    counter="15"
                    label="Numéro"
                    hint="le numero"
                    type="text"
                    v-model="account.address.numero"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    name="rue"
                    label="Rue"
                    maxlength="50"
                    counter="50"
                    hint="Le nom de la rue"
                    type="text"
                    v-model="account.address.rue"
                    :rules="rules.addressRue"
                  >
                    <template #label>
                      Rue<span class="text-red"><strong> *</strong></span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    name="codepostale"
                    maxlength="5"
                    counter="5"
                    hint="Le code postale de la ville"
                    type="text"
                    v-model="account.address.codepostale"
                    :rules="rules.addressCodePostale"
                  >
                    <template #label>
                      Code Postale<span class="text-red"><strong>* </strong></span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    name="ville"
                    maxlength="50"
                    counter="50"
                    hint="Le nom de la ville"
                    type="text"
                    v-model="account.address.ville"
                    :rules="rules.addressVille"
                  >
                    <template #label>
                      Ville<span class="text-red"><strong> *</strong></span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col md="12" cols="12">
                  <v-textarea
                    name="observation"
                    label="Observation"
                    v-model="account.observation"
                  >
                  </v-textarea>
                </v-col>
                <v-row v-if="laveries?.length">
                  <v-col v-for="item in laveries" :key="item.id" cols="12" md="6" lg="4">
                    <v-card elevation="2">
                      <v-card-title class="text-blue">
                        {{ item.name }}
                      </v-card-title>

                      <v-card-text>
                        <div>
                          <strong>Numéro de contrat:</strong> {{ item.numeroDeContrat }}
                        </div>
                        <div><strong>Gestionnaire:</strong> {{ item.gestionnaire }}</div>
                        <div>
                          <strong>Adresse:</strong>
                          {{ item.address?.numero }}
                          {{ item.address?.rue }},
                          {{ item.address?.codepostale }}
                          {{ item.address?.ville }}
                        </div>
                        <div>
                          <strong>Téléphone:</strong> {{ item.telephonePrincipal }}
                        </div>
                        <div><strong>Courriel:</strong> {{ item.email }}</div>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn icon color="teal" @click="edit(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon color="cyan" @click="remove(item)">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmDialog
      v-model="removeLaverieDialog"
      :dialogTitle="dialogTitle"
      :dialogText="dialogText"
      @confirm="onConfirm"
      @cancel="onCancel"
    ></ConfirmDialog>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useAppStore } from "@/store/app";
import { AccountOrigin, FamilleLaverie } from "@/types";
import type { Laverie } from "@/types";
import {
  isNotEmpty,
  isValidCodePostale,
  isValidEmail,
  isValidPhoneNumber,
} from "@/utils/validation-util";
import { getAccountById, postAccount, putAccount } from "@/utils/account-api";
import { deleteLaverie, getLaveriesByAccountId } from "@/utils/laverie-api";
import type { Account } from "@/types";
import { getAllUsers } from "@/utils/user-api";
import type { User } from "@/types";

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();

const createEmptyAccount = (): Account => ({
  name: "",
  signataire: "",
  fonctionSignataire: "",
  telephone: "",
  email: "",
  famille: undefined,
  origineCompte: undefined,
  porteurProjet: undefined,
  siret: "",
  website: "",
  observation: "",
  nbLaveries: 0,
  address: {
    numero: "",
    rue: "",
    codepostale: "",
    ville: "",
  },
});

const removeLaverieDialog = ref(false);
const dialogTitle = "Suppression";
const dialogText = "Vouez-vous supprimer cette laverie?";
const selectedLaverieToRemove = ref<Laverie | null>(null);
const title = ref("");
const account = ref<Account>(createEmptyAccount());
const laveries = ref<Laverie[]>([]);
const users = ref<User[]>([]);
const loading = ref(false);

const familleLaveries = Object.values(FamilleLaverie);
const accountOrigins = Object.values(AccountOrigin);

const rules = {
  phoneNb: [
    () => isValidPhoneNumber(account.value.telephone) || "Numéro de téléphone invalide",
  ],
  email: [() => isValidEmail(account.value.email) || "Email invalide"],
  accountName: [() => isNotEmpty(account.value.name) || "Le nom du siège est requis"],
  accountSignataire: [
    () => isNotEmpty(account.value.signataire) || "Le signataire est requis",
  ],
  accountFonctionSignataire: [
    () =>
      isNotEmpty(account.value.fonctionSignataire) ||
      "La fonction du signataire est requise",
  ],
  addressRue: [() => isNotEmpty(account.value.address?.rue) || "La rue est requise"],
  addressVille: [
    () => isNotEmpty(account.value.address?.ville) || "La ville est requise",
  ],
  addressCodePostale: [
    () =>
      isValidCodePostale(account.value.address?.codepostale) || "Code postal invalide",
  ],
};

const save = async () => {
  try {
    loading.value = true;
    const accountData = { ...account.value };

    if (!accountData.id) {
      account.value = await postAccount(accountData);
      appStore.sendSuccessNotice("New Account has been added.");
      router.replace({
        name: "account",
        params: { id: account.value.id },
      });
      title.value = "Editer le siège";
    } else {
      await putAccount(accountData.id!, accountData);
      appStore.sendSuccessNotice("Account has been updated.");
    }
  } catch (error) {
    // Ignore, handled centraly in axios service
  } finally {
    loading.value = false;
  }
};

const cancel = () => {
  router.push({ name: "accounts" });
};

const edit = (item: Laverie) => {
  router.push({ name: "laverie", params: { id: item.id } });
};

const remove = (laverie: Laverie) => {
  selectedLaverieToRemove.value = laverie;
  removeLaverieDialog.value = true;
};

const onConfirm = async () => {
  if (!selectedLaverieToRemove.value) return;

  const id = selectedLaverieToRemove.value.id!;
  selectedLaverieToRemove.value = null;
  removeLaverieDialog.value = false;

  await deleteLaverie([id]);
  const accountId = route.params.id as string;
  laveries.value = await getLaveriesByAccountId(accountId);
};

const onCancel = () => {
  selectedLaverieToRemove.value = null;
  removeLaverieDialog.value = false;
};

const createNewLaverie = () => {
  if (route.params.id) {
    router.push({
      name: "newlaverieforaccount",
      params: {
        accountId: route.params.id as string,
        accountName: account.value.name,
        showTaskListPanel: "false",
      },
    });
  }
};

const isCreatingNewAccount = computed(
  () => route.name === "newaccount" || route.params.id === "NewAccount"
);

onMounted(async () => {
  try {
    loading.value = true;
    if (isCreatingNewAccount.value) {
      title.value = "Nouveau siège";
      users.value = await getAllUsers();
    } else {
      title.value = "Editer le siège";
      const accountId = route.params.id as string;

      const [accountData, laveriesData, usersData] = await Promise.all([
        getAccountById(accountId),
        getLaveriesByAccountId(accountId),
        getAllUsers(),
      ]);

      account.value = accountData;
      laveries.value = laveriesData;
      users.value = usersData;
    }
  } catch (error) {
  } finally {
    loading.value = false;
  }
});
</script>
